export default __webpack_public_path__ + "static/logo-e7db28851e77f31de5aba9978d5991fb.png";